export const DEFAULT_FORMAT = 'YYYY-MM-DD'
export const PRETTY_FORMAT = 'MMM DD, YYYY'
export const BASIC_FORMAT = 'MMM D YYYY'
export const DATE_TIME_FORMAT = 'MMM D YYYY hh:ss A'
